<template>
	<div id="app"><router-view /></div>
</template>

<script>
export default {
	provide() {
		return {};
	},
	beforeCreate() {}
};
</script>

<style>
#app {
	font-family: 'Helvetica';
	text-align: center;
	color: #2c3e50;
	letter-spacing: 1px;
	height: 100vh;
	width: 100vw;
}
</style>
<style lang="less">
/*flex 布局*/

.flex {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
}

/*垂直显示*/

.flex-v {
	-webkit-box-orient: vertical;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}

.flex-1 {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-ms-flex: 1;
	flex: 1;
	overflow: hidden;
}

/*垂直对其方式*/

.flex-align-center {
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
}

.flex-align-end {
	-webkit-box-align: end;
	-webkit-align-items: flex-end;
	-ms-flex-align: end;
	align-items: flex-end;
}

/*左右居中*/

.flex-pack-center {
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
}

/*两端对齐*/

.flex-pack-justify {
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-ms-flex-pack: justify;
	justify-content: space-between;
}

.flex-wrap {
	flex-wrap: wrap;
}
.father-module {
	height: 100%;
	margin: 0 20px;
	box-sizing: border-box;
	border-radius: 12px;
	border: 1px solid transparent;
	background-image: linear-gradient(180deg, rgba(11, 80, 217, 0.8) 0%, rgba(16, 34, 94, 0.8) 100%), linear-gradient(180deg, #0ee2de 0%, rgba(26, 45, 111, 0) 100%);
	background-origin: border-box;
	background-clip: content-box, border-box;
	& > div {
		padding: 0 22px;
	}
	::-webkit-scrollbar {
		width: 5px;
		height: 15px;
	}
	::-webkit-scrollbar-thumb {
		border-radius: 5px;
		background: #1884d8;
	}
	::-webkit-scrollbar-track {
		border-radius: 0;
		background: rgba(0, 0, 0, 0.3);
	}
}

.father-module .title-module {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: 800;
	color: #ffffff;
	letter-spacing: 2px;
	margin: 0 0 20px 0;
	padding-top: 20px;
	position: relative;
	.title-module-img {
		width: 200px;
		height: 52px;
		position: absolute;
		left: 0;
	}
	span {
		margin-left: 20px;
		font-size: 14px;
		font-weight: 400;
		color: #b4ceff;
		letter-spacing: 1px;
	}
	.icon {
		width: 25px;
		height: 19px;
	}
	.more {
		height: 32px;
		padding: 0 10px;
		background: #1b3690;
		border: 1px solid #0158f1;
		box-shadow: 0px 0px 5px rgba(85, 132, 255, 0.5);
		border-radius: 4px;
		color: #dedede;
		line-height: 32px;
		margin-top: 20px;
		&:hover {
			text-decoration: none;
		}
	}
	.details {
		font-size: 16px;
		font-weight: 400;
		color: #b4ceff;
		// line-height: 24px;
	}

	.el-table__body tr.hover-row > td.el-table__cell {
		background: none;
	}
}
</style>
